import Skeleton from '@mui/material/Skeleton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import type { DecoratedOrderProduct } from '@witmetrics/utils';
import { sortByCreatedAt } from '@witmetrics/utils/arrays';
import OrderProductsListItem from './OrderProductsListItem';
import { classes, styles } from './utils';

export type OrderProductsListProps = {
  isFetchingData: boolean;
  className?: string;
  orderProducts: DecoratedOrderProduct[];
};

export default function OrderProductsList({
  isFetchingData,
  className,
  orderProducts = [],
}: OrderProductsListProps) {
  const sortedProducts = sortByCreatedAt(orderProducts);

  return (
    <List className={className}>
      {isFetchingData
        ? [0, 0.2, 0.3].map((delay) => (
            <ListItem key={delay} sx={styles.listItem}>
              <Skeleton
                sx={styles.skeleton(delay)}
                className={classes.skeleton}
                variant="rectangular"
                animation="wave"
              />
            </ListItem>
          ))
        : sortedProducts.map(({ id }) => (
            <OrderProductsListItem key={id} orderProductId={id} />
          ))}
    </List>
  );
}
